import React from 'react';
import { Box } from '@mui/material';

import { BacklogGrid } from './BacklogGrid';

export function Backlog() {
  return (
    <Box sx={{ flexGrow: 1, height: 'inherit' }}>
      <BacklogGrid />
    </Box>
  );
}
